module.exports = __webpack_public_path__ + "img/samplemap.2f77dcf3.jpg";